export default __webpack_public_path__ + "static/media/Beard_7_C2.dae1acf8.svg";